export const PRESENCE_STATUS_ACCEPTED = 'accepted';
export const PRESENCE_STATUS_PENDING = 'pending';
export const PRESENCE_STATUS_REJECTED = 'rejected';
export const PRESENCE_TYPE_IN_PERSON = 'in_person';
export const PRESENCE_TYPE_REMOTE = 'remote';
export const PRESENCE_TYPE_OOO = 'out_of_office';

export type PRESENCE_STATUS_PENDING = typeof PRESENCE_STATUS_PENDING;
export type PRESENCE_STATUS_ACCEPTED = typeof PRESENCE_STATUS_ACCEPTED;
export type PRESENCE_STATUS_REJECTED = typeof PRESENCE_STATUS_REJECTED;
export type PRESENCE_TYPE_IN_PERSON = typeof PRESENCE_TYPE_IN_PERSON;
export type PRESENCE_TYPE_REMOTE = typeof PRESENCE_TYPE_REMOTE;
export type PRESENCE_TYPE_OOO = typeof PRESENCE_TYPE_OOO;

export type PresenceStatus =
  | PRESENCE_STATUS_ACCEPTED
  | PRESENCE_STATUS_PENDING
  | PRESENCE_STATUS_REJECTED;
export type PresenceType =
  | PRESENCE_TYPE_IN_PERSON
  | PRESENCE_TYPE_REMOTE
  | PRESENCE_TYPE_OOO;
